import { useContext } from 'react';
import { LoginStateContext } from './LoginStateContext';

export function useLoginState() {
  const context = useContext(LoginStateContext);

  if (!context) {
    throw new Error('useLoginState must be used within a LoginStateProvider');
  }

  const { loginFormMethods, ...loginStateOnly } = context;
  return loginStateOnly;
}
